module.exports = __webpack_public_path__ + "static/media/hex-viewer.32e14681.svg";